/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerifyMicrodepositsResponse
 */
export interface VerifyMicrodepositsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof VerifyMicrodepositsResponse
     */
    success: boolean;
    /**
     * Present when success is false. Safe to surface to the customer.
     * @type {string}
     * @memberof VerifyMicrodepositsResponse
     */
    errorMessage?: string;
}

/**
 * Check if a given object implements the VerifyMicrodepositsResponse interface.
 */
export function instanceOfVerifyMicrodepositsResponse(value: object): value is VerifyMicrodepositsResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    return true;
}

export function VerifyMicrodepositsResponseFromJSON(json: any): VerifyMicrodepositsResponse {
    return VerifyMicrodepositsResponseFromJSONTyped(json, false);
}

export function VerifyMicrodepositsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyMicrodepositsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
    };
}

  export function VerifyMicrodepositsResponseToJSON(json: any): VerifyMicrodepositsResponse {
      return VerifyMicrodepositsResponseToJSONTyped(json, false);
  }

  export function VerifyMicrodepositsResponseToJSONTyped(value?: VerifyMicrodepositsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'errorMessage': value['errorMessage'],
    };
}

